import type { ForgotPasswordFormCopy, ForgotPasswordStep } from './models';
import { text as moduleText } from './text';
import { text as sharedText } from '@shared/text';

export const text = {
  forgotPasswordFormCopy(step: ForgotPasswordStep, isSubmitting: boolean): ForgotPasswordFormCopy {
    if (step === 'request') {
      return {
        title: moduleText.title,
        subtitle: moduleText.subtitle,
        submitButtonLabel: isSubmitting ? sharedText.loading : moduleText.sendCode,
        cancelLabel: moduleText.backToLogin,
        emailLabel: sharedText.email,
        codeLabel: moduleText.code,
        newPasswordLabel: moduleText.newPassword,
      };
    }

    return {
      title: moduleText.verifyTitle,
      subtitle: moduleText.verifySubtitle,
      submitButtonLabel: isSubmitting ? sharedText.loading : moduleText.reset,
      cancelLabel: moduleText.startOver,
      emailLabel: sharedText.email,
      codeLabel: moduleText.code,
      newPasswordLabel: moduleText.newPassword,
    };
  },
};
